import React, { useState } from 'react';
import getName from '../../../../../../helpers/getName';
import { useMeasure } from '../../../../../../hooks/useMeasure';
import TextWithTooltip from '../../../../../../components/TextWithTooltip/TextWithTooltip';
import BlockWithExtraContent from '../../../../../../components/BlockWithExtraContent/BlockWithExtraContent';
import ToggleExpandBtn from '../ToggleExpandBtn/ToggleExpandBtn';
import styles from './ExecutorList.module.scss';

const maxSize = 2;

const Executors = ({ executors }) => {
  const [showAll, setShowAll] = useState();

  const [ref, { width }] = useMeasure();

  const itemsToRender = showAll ? executors : executors.slice(0, maxSize);

  return (
    <ul
      ref={ref}
      className={styles.root}
    >
      {itemsToRender.map((executor) => {
        const name = getName(executor);

        return (
          <li key={executor.id}>
            <TextWithTooltip
              parentWidth={width}
              mainTitle={[
                name,
                Boolean(executor.speciality) &&
                  `(${executor.speciality.trim()})`,
              ]
                .filter(Boolean)
                .join(' ')}
              render={({ textRef }) => (
                <BlockWithExtraContent
                  ref={textRef}
                  main={name}
                  extra={executor.speciality}
                />
              )}
            />
          </li>
        );
      })}

      {executors.length > maxSize && (
        <li>
          <ToggleExpandBtn
            onClick={() => setShowAll((prev) => !prev)}
            text={showAll ? 'Скрыть' : `+ еще ${executors.length - maxSize}`}
          />
        </li>
      )}
    </ul>
  );
};

const ExecutorList = ({ executors }) => {
  return executors?.length ? <Executors executors={executors} /> : 'Не указаны';
};

export default ExecutorList;
